export const WorkOrderItemActionTypes = {
  DISPUTE: "dispute",
  UNCOMPLETED: "uncompleted",
};
